import React, { useRef, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import Formsy from "formsy-react";
import { useAsyncSetState } from "use-async-setstate";
import { useMutation } from "@apollo/client";
import {getOperationName} from "apollo-utilities";

import TextField from "../../bootstrap/input";
import Modal from "../../bootstrap/modal";
import {updateDeviceMutation} from "../../logic/device";
import { getCurrentUserQuery } from "../../logic/user";

export default function ChangeDetails(props) {
  const [state, setState] = useAsyncSetState({
    processing: false,
    error: "",
  });
  const [canSubmit, setCanSubmit] = useState(false);

  const { onClose, device } = props;
  const formRef = useRef(null);
  const [updateDevice] = useMutation(updateDeviceMutation);

  async function handleSubmit({hostname, macAddress}) {
    await setState((prevState) => ({ ...prevState, processing: true }));

    try {
      await updateDevice({
        variables: {
          hostname,
          id: device.id
        },
        awaitRefetchQueries: true,
        refetchQueries: [getOperationName(getCurrentUserQuery)],
      })

      await setState((prevState) => ({ ...prevState, processing: false }));
      return onClose();
    } catch (err) {
      return setState((prevState) => ({ ...prevState, processing: false, error: err }));
    }
  }

  return (
    <Modal
      title={"Edit Device"}
      show
      onClose={async() => onClose()}
      className="edit-device-modal"
      footer={
        <Container>
          <Row>
            <Col xs="auto ml-auto" className="pl-1 pr-1">
              <Button
                className="vw-button btn btn-white"
                type="button"
                disabled={state.processing}
                onClick={(e) => {
                  e.preventDefault();
                  return onClose();
                }}
                id="cancel-button"
              >
                {"Cancel"}
              </Button>
            </Col>
            <Col xs="auto" className="pl-1 pr-1">
              <Button
                className="vw-button btn btn-blue"
                type="submit"
                disabled={state.processing || !canSubmit}
                onClick={() => formRef.current.submit()}
                id="save-button"
              >
                {"Save"}
              </Button>
            </Col>
          </Row>
        </Container>
      }
    >
      <Formsy
        ref={formRef}
        onValidSubmit={handleSubmit}
        onValid={() => setCanSubmit(true)}
        onInvalid={() => setCanSubmit(false)}
      >
        {state.error && <Row>
          <Col>
            <div className="alert alert-danger">
              {state.error}
            </div>
          </Col>
        </Row>}
        <Row className="field-row mb-2">
          <Col>
            <TextField
              inline
              label={"Mac Address"}
              placeholder={"Mac Address"}
              defaultValue={device?.macAddress}
              name="macAddress"
              disabled
              required
            />
          </Col>
        </Row>
        <Row className="field-row mb-2">
          <Col>
            <TextField
              inline
              label={"Name"}
              name="hostname"
              defaultValue={device?.hostname}
              placeholder={"Name"}
              required
            />
          </Col>
        </Row>
      </Formsy>
    </Modal>
  );
}
